import React, { useContext, useState, useEffect } from "react"
import { CanvasContext } from "../hooks/LessonPage"
import "./VideoImageElement.scss"
import ReactHtmlParser from "react-html-parser"
import { Button, Modal, Drawer } from 'antd';
import {  Input,Typography, Form } from 'antd';
import {  Box, Grid, Flex } from 'theme-ui'

const EmbedElement = props => {
    const { metadata, id, position, dimension, type } = props
    const { state, actions } = useContext(CanvasContext)
    const [open, setOpen] = useState(false);
    const elementRef = React.useRef(null)
    const [text, setText] = useState("");
    const [targetRef, setTargetRef] = useState(null)
    const [showGrids, setShowGrids] = React.useState(false)
    const [formLayout, setFormLayout] = useState('vertical');
    const [form] = Form.useForm();
    const variant = Form.useWatch('variant', form);

  const onClick = (e) => {
    e.stopPropagation();
    actions?.setTargetRef(elementRef)
    actions?.setCurrentElementId(id)
    var activeContent ={id : id, type : type , metadata : metadata, dimension : dimension, position : position }
    actions?.setActiveEditable(activeContent)    
  }

  const onFinish = (values) => {
    var contentData = { id: id, content: values.embedHTML }
    actions.updateCanvasData(contentData)
    setOpen(false);
    actions.setTargetRef(targetRef)
  };
  
  const textDoubleClick = (e) => {
    e.stopPropagation();
    setText("")
    setOpen(true)

    setTimeout(function () {
       setText(metadata.content)
    }, 100);

    setTargetRef(state?.targetRef)
    actions.setTargetRef(null)
 }


  const onEnter = (e,value) =>
  {
    e.stopPropagation()
    e.preventDefault()
    setShowGrids(value)
  }

  const handleCancel = () => {
    setOpen(false);
    actions.setTargetRef(targetRef)

 };

  const renderElement = (type) =>
  {
    return(
          <>
            <div 
                ref={elementRef} 
                // dangerouslySetInnerHTML={{ __html: props.metadata.content }}
                onClick={(e) => onClick(e)}       
                onMouseEnter={(e) =>  onEnter(e,true)}
                onMouseLeave={(e) =>  onEnter(e,false)}            
                onDoubleClick={(e) => textDoubleClick(e)}                      
                 style={{ position : "absolute",  
                          pointerEvents :"auto",
                          left: position?.left || 0, 
                          top: position?.top || 0,
                          width: dimension?.width || 0, 
                          height: dimension?.height || 0,   
                          transform : dimension?.transform || "translate(1px, 1px)",                 
                          fontFamily: "Arial",
                          fontSize: "13px",
                          padding: 0,
                          float : "left",
                          backgroundColor : (type === "WEB" && type === "EMBED") ? "white" : "transparent",
                          borderRadius : (type === "WEB" && type === "EMBED")  ? "10px" : "",
                          border :(type === "WEB" && type === "EMBED")  ? "1px solid black" : "",
                          border: `2px solid ${
                            showGrids 
                              ? "#21DEE5"
                              : "transparent"
                          }`,                            
                        }}>
             <div style={{ height: "100%", width: "100%", pointerEvents : props.isreadonly === true ? "none" : "" }}>
               {ReactHtmlParser(metadata.content || "")}
            </div>                      
         </div>   
         <Drawer title="Edit Embed HTML" onClose={handleCancel} open={open}>
          <Grid sx={{ gridTemplateRows: '50px 50px 50px' }}>
            <Box sx={{ fontWeight: 600, fontSize: '2rem', margin : "1rem 1rem" }}>
            <Form
                layout={formLayout}
                form={form}
                initialValues={{
                  layout: formLayout,
                  embedHTML : metadata.content
                }}
                style={{
                  maxWidth: formLayout === 'inline' ? 'none' : 600,
                }}   
                onFinish={onFinish}           
              >             
              <Form.Item
                label="Enter your Embedded HTML :"
                name="embedHTML"
                rules={[{  pattern: new RegExp(/(https):\/\/([\w.]+\/?)\S*/), required: true, message: 'Please enter a valid embed html here!' }]}
              >
                <Input.TextArea  
                  style={{ height: 320, resize: 'none' }}      
                  // defaultValue={metadata.content}   
                  // value={metadata.content}     
                />
              </Form.Item>   

              <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>                  
          </Form>
          </Box>
        </Grid>     
         </Drawer>         
            </>
    )     
  } 

  return (
    renderElement(type)
  )
}

export default EmbedElement
